import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button, FlexRow } from "@similarweb/ui-components";

export const StyledButton = styled(Button)`
    border: 1px solid ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon[200] : colorsPalettes.red[400])};

    div {
        color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon[200] : colorsPalettes.red[400])};
    }

    &:hover {
        ${({ isDisabled }) =>
            !isDisabled &&
            css`
                border: 1px solid ${colorsPalettes.red[400]};

                div {
                    color: ${colorsPalettes.red[400]};
                }
            `}
    }

    &:active {
        border: 1px solid ${colorsPalettes.red[500]};
        background: ${colorsPalettes.red[300]};
    }
`;

export const StyledFlexRow = styled(FlexRow)`
    align-items: center;
`;

export const TextWrapper = styled.div`
    padding-right: 16px;
`;

export const DeleteWrapper = styled.div`
    padding-bottom: 24px;
`;
